function initAjaxGlossary() {
  if ($('#glossary-module-posts').length == 0) {
    return false;
  }

  const ajaxPosts = $('#glossary-module-posts');
  const searchField = $('#ajax-glossary-search-field');
  const searchButton = $('#ajax-glossary-search-button');
  const clearButton = $('#glossary-module-button');
  const result = $('#glossary-module-result');
  const letters = $('#glossary-module-letters');
  const returnButton = $('#glossary-module-return-button');
  let typingTimer;
  let doneTypingInterval = 800;

  getPosts();

  returnButton.on('click', function () {
    window.scroll({
      top: searchField.offset().top - 64,
      left: 0,
      behavior: 'smooth',
    });
  });

  clearButton.on('click', function () {
    searchField.val('');
    getPosts();
  });

  searchButton.on('click', function () {
    console.log(1);
    getPosts();
  });

  searchField.on('search', function () {
    if ($(this).val().length == 0) {
      getPosts();
    }
  });

  searchField.bind('enterKey', function () {
    getPosts();
  });

  searchField.keyup(function (e) {
    if (e.keyCode == 13) {
      $(this).trigger('enterKey');
    }
  });

  searchField.keyup(function () {
    clearTimeout(typingTimer);

    if (!searchField.val() || searchField.val().length > 1) {
      typingTimer = setTimeout(function () {
        getPosts();
      }, doneTypingInterval);
    }
  });

  function getPosts() {
    const keyword = getKeyword();

    let data = {
      action: 'get_glossary',
      nonce: fpm001_localize.nonce,
      keyword: keyword,
    };

    $.post(fpm001_localize.ajax_url, data, function (response) {
      result.html('').removeClass('active');
      letters.html('');
      clearButton.removeClass('active');

      if (response.data) {
        ajaxPosts.html(response.data.html_posts);

        if (keyword) {
          clearButton.addClass('active');
        }

        if (response.data.result !== undefined) {
          result.html(response.data.result).addClass('active');
        }

        if (response.data.letters !== undefined) {
          letters.html(response.data.letters);
        }
      }
    });
  }

  function getKeyword() {
    const keyword = searchField.val();
    return $.trim(keyword);
  }
}

export { initAjaxGlossary }



// WEBPACK FOOTER //
// ./scripts/modules/ajax-glossary.js